<task-list-simple-table [cardHeader]="'Global'"></task-list-simple-table>
<ng-container *ngIf="tasksMap.get(url)">
    <task-list-simple-table [cardHeader]="tasksMap.get(url)"></task-list-simple-table>
</ng-container>